import { MdClose } from "react-icons/md";
import jsPDF from "jspdf";
import { FaDownload } from "react-icons/fa";
import pageone from "../../assets/img/pageone.jpg";
import pagetwo from "../../assets/img/pagetwo.jpg";
import pagethree from "../../assets/img/pagethree.jpg";
import pagefour from "../../assets/img/pagefour.jpg";
import pagefive from "../../assets/img/pagefive.jpg";
import pagesix from "../../assets/img/pagesix.jpg";
import pageseven from "../../assets/img/pageseven.jpg";
import pageeight from "../../assets/img/pageeight.jpg";

const profileImageUrls = [
  pageone,
  pagetwo,
  pagethree,
  pagefour,
  pagefive,
  pagesix,
  pageseven,
  pageeight,
];

const ProfileModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleDownload = async () => {
    const doc = new jsPDF("portrait", "pt", "a4"); // Start with portrait A4

    for (let i = 0; i < profileImageUrls.length; i++) {
      const imageUrl = profileImageUrls[i];
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.onload = async () => {
          const imgData = reader.result;
          const img = new Image();
          img.onload = () => {
            const imgWidth = img.width;
            const imgHeight = img.height;

            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            const aspectRatio = imgWidth / imgHeight;
            let finalWidth = pageWidth;
            let finalHeight = pageHeight;

            // Scale image to fit page, maintaining aspect ratio
            if (imgWidth > imgHeight) {
              // Landscape image
              finalHeight = pageWidth / aspectRatio;
              if (finalHeight > pageHeight) {
                finalHeight = pageHeight;
                finalWidth = pageHeight * aspectRatio;
              }
            } else {
              // Portrait image
              finalWidth = pageHeight * aspectRatio;
              if (finalWidth > pageWidth) {
                finalWidth = pageWidth;
                finalHeight = pageWidth / aspectRatio;
              }
            }

            // Center the image on the page
            const x = (pageWidth - finalWidth) / 2;
            const y = (pageHeight - finalHeight) / 2;

            if (i > 0) {
              doc.addPage(); // Add a new page for subsequent images
            }
            doc.addImage(imgData, "JPEG", x, y, finalWidth, finalHeight);

            if (i === profileImageUrls.length - 1) {
              // Only save after the last image has been added
              doc.save("CEPHAS-KIDS-TECH-EXTRA-Profile.pdf");
            }
          };
          img.src = imgData;
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error(`Error downloading image ${imageUrl} as PDF:`, error);
        alert("Failed to download profile. Please try again.");
        return; // Stop if an image fails to load
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[95vh] overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-2xl font-bold text-[#113296]">
            Cephas Kids Tech Extra Profile Preview
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <MdClose className="w-6 h-6" />
          </button>
        </div>
        {/* Content - Display all profile images */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)] space-y-6">
          {profileImageUrls.map((url, index) => (
            <div key={index} className="mb-6">
              <img
                src={url || "/placeholder.svg"}
                alt={`Profile Page ${index + 1}`}
                className="w-full h-auto rounded-lg shadow-lg border border-gray-200"
              />
            </div>
          ))}
        </div>
        {/* Footer */}
        <div className="flex justify-end gap-4 p-6 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Close
          </button>
          <button
            onClick={handleDownload}
            className="px-6 py-2 bg-[#FF4B01] text-white rounded-lg hover:bg-orange-600 transition-colors flex items-center gap-2"
          >
            <FaDownload className="w-4 h-4" />
            Download Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
